import React, { useEffect } from 'react';
import { FileText, AlertCircle, Scale, Gavel } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import PageHero from '../components/PageHero';

const TermsConditions = () => {
  useEffect(() => {
    document.title = 'Terms & Conditions | Digi Loans Bazaar - Hyderabad';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Terms and Conditions for using Digi Loans Bazaar loan consultancy services. Read our terms before applying for business or hospital loans.');
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32">
        <PageHero
          badge="Legal Terms"
          badgeIcon={Scale}
          title="Terms &"
          highlightWord="Conditions"
          subtitle="Last updated: December 2026"
          breadcrumb="Terms & Conditions"
        />
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">

            <div className="prose prose-lg max-w-none">
              <div className="bg-amber-50 border-l-4 border-amber-500 rounded-r-xl p-6 mb-8">
                <p className="text-gray-800 m-0">
                  By using the services of <strong>Digi Loans Bazaar</strong>, you agree to comply with and be bound by these Terms & Conditions.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4 flex items-center gap-3">
                <FileText className="w-6 h-6 text-amber-600" /> Service Description
              </h2>
              <p className="text-gray-700">
                Digi Loans Bazaar is a financial consultancy that facilitates loans by connecting customers with banks and NBFCs. We do not directly disburse loans; final approval and terms are at the discretion of the lending institution.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4 flex items-center gap-3">
                <AlertCircle className="w-6 h-6 text-amber-600" /> Eligibility
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-6">
                <li>You must be at least 21 years of age</li>
                <li>You must be an Indian citizen or legal resident</li>
                <li>You must provide accurate and truthful information</li>
                <li>You must meet the eligibility criteria of the lending bank/NBFC</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Loan Application Process</h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-6">
                <li>All loan approvals are subject to bank/NBFC policies and verification</li>
                <li>Interest rates and terms are determined by the lending institution</li>
                <li>Processing fees, if any, are payable as per the lender's policy</li>
                <li>Documentation requirements may vary based on the loan type</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4 flex items-center gap-3">
                <Gavel className="w-6 h-6 text-amber-600" /> Disclaimer
              </h2>
              <p className="text-gray-700">
                "Up to 100% Project Financing" and "No Collateral Required" are subject to loan type, eligibility, and lender approval. Actual loan terms may differ.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Limitation of Liability</h2>
              <p className="text-gray-700">
                Digi Loans Bazaar acts as a facilitator and is not responsible for loan rejections, delays in approval, or terms offered by the lending institutions. We do not guarantee loan approval.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Intellectual Property</h2>
              <p className="text-gray-700">
                All content on this website, including logos, text, images, and graphics, is the property of Digi Loans Bazaar and is protected by copyright laws.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Governing Law</h2>
              <p className="text-gray-700">
                These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Hyderabad, Telangana.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contact</h2>
              <p className="text-gray-700">
                Email: <a href="mailto:prasad@digiloansbazaar.com" className="text-blue-600 hover:underline">prasad@digiloansbazaar.com</a><br />
                Phone: <a href="tel:+919703850009" className="text-blue-600 hover:underline">+91 9703850009</a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default TermsConditions;
